"use strict";

import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import PlaylistPlayRoundedIcon from "@mui/icons-material/PlaylistPlayRounded";
import SubtitlesRoundedIcon from "@mui/icons-material/SubtitlesRounded";
import UploadFileIcon from "@mui/icons-material/UploadFile";

// Where the new video comes from: the same two sources project creation offers.
export const RELOAD_VIDEO_SOURCES = [
    {
        value: "file",
        title: "Upload file",
        description: "A video on this computer",
        icon: UploadFileIcon,
    },
    {
        value: "google-drive",
        title: "Google Drive",
        description: "A shared Drive link",
        icon: DriveFolderUploadIcon,
    },
];

// What runs once the video has loaded. The values are the API execution modes.
export const RELOAD_VIDEO_RUN_OPTIONS = [
    {
        value: "through_transcription",
        title: "Through transcription",
        description: "Separates the stems and transcribes",
        icon: SubtitlesRoundedIcon,
        tone: "info",
    },
    {
        value: "full",
        title: "Full workflow",
        description: "Also translates, trains voices and creates takes",
        icon: PlaylistPlayRoundedIcon,
        tone: "warning",
    },
];

export const isValidVideoUrl = (url) =>
    /^(ftp|http|https):\/\/[^ "]+$/.test(String(url || "").trim());

// A fresh name per upload keeps the project's earlier source file intact.
export const reloadVideoObjectName = (projectName, fileName, now = Date.now()) =>
    `${projectName}/reload_${now}_${fileName}`;

// The body of the end-to-end automation request that reloads a project's video.
export const buildReloadVideoRequest = ({
    projectId,
    projectName,
    url,
    executionMode,
    stemSeparationProvider,
}) => ({
    projectId,
    projectName,
    url,
    // A reloaded video brings no stems of its own, so stem separation runs.
    demucs: true,
    // Uploaded files and Drive links are both read by the Drive ingestion task.
    isDrive: true,
    executionMode,
    stemSeparationProvider,
});
